import React from "react";
import { Popover, Table } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { useIntl } from "react-intl";

const TimewatchPopover = ({ record, timewatchEvents, holidays }) => {
  const intl = useIntl();
  if (!record || !record.start || !timewatchEvents) return null;

  const eventDate = moment(record.start).startOf("day");
  const relevantEvents = timewatchEvents.filter(
    (event) =>
      event.entrance_date &&
      moment(event.entrance_date).startOf("day").isSame(eventDate)
  );

  if (relevantEvents.length === 0) return null;

  const calculateHours = (entrance, exit) => {
    if (!entrance || !exit) return null;
    const duration = moment.duration(moment(exit).diff(moment(entrance)));
    return Number(duration.asHours().toFixed(2));
  };

  const totalHours = relevantEvents
    .reduce((sum, event) => {
      const hours = calculateHours(event.entrance_date, event.exit_date);
      return sum + (hours || 0);
    }, 0)
    .toFixed(2);

  const columns = [
    {
      title: intl.formatMessage({ id: "app.scheduling.timewatch.date" }),
      dataIndex: "entrance_date",
      key: "date",
      render: (text) => moment(text).format("DD/MM/YYYY"),
    },
    {
      title: intl.formatMessage({ id: "app.scheduling.timewatch.dayOfWeek" }),
      dataIndex: "entrance_date",
      key: "dayOfWeek",
      render: (text) => moment(text).format("dd"),
    },
    {
      title: intl.formatMessage({ id: "app.scheduling.timewatch.entrance" }),
      dataIndex: "entrance_date",
      key: "entrance_date",
      render: (text) => (text ? moment(text).format("HH:mm") : "-"),
    },
    {
      title: intl.formatMessage({ id: "app.scheduling.timewatch.exit" }),
      dataIndex: "exit_date",
      key: "exit_date",
      render: (text) => (text ? moment(text).format("HH:mm") : "-"),
    },
    {
      title: intl.formatMessage({ id: "app.scheduling.timewatch.hours" }),
      key: "hours",
      render: (_, record) =>
        calculateHours(record.entrance_date, record.exit_date) || "-",
    },
  ];

  const getRowClassName = (record) => {
    const date = moment(record.entrance_date);
    const isHoliday = holidays.some((holiday) =>
      moment(holiday.date).isSame(date, "day")
    );

    let className = "timewatch-event-row";
    if (date.day() === 6) {
      className += " saturday-row";
    }
    if (isHoliday) {
      className += " saturday-row";
    }

    return className;
  };

  const popoverTitle = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <div>
        {intl.formatMessage({
          id: "app.scheduling.timewatch.events",
        })}
        <div style={{ fontSize: "0.9em", color: "#888" }}>
          {intl.formatMessage({ id: "app.scheduling.timewatch.totalHours" })}:{" "}
          {totalHours}
        </div>
      </div>
      <div style={{ fontWeight: "normal" }}>
        {eventDate.format("DD/MM/YYYY")}
      </div>
    </div>
  );

  return (
    <Popover
      placement="top"
      title={popoverTitle}
      trigger="hover"
      destroyTooltipOnHide
      content={
        <Table
          columns={columns}
          dataSource={relevantEvents}
          pagination={false}
          size="small"
          rowClassName={getRowClassName}
        />
      }
    >
      <ClockCircleOutlined style={{ color: "#1890ff", marginLeft: 8 }} />
    </Popover>
  );
};

export default TimewatchPopover;
